function getPixelRatio() {
  return window.devicePixelRatio || 1;
}

export {
  getPixelRatio,
};
